import { FundsDetailsTypes, UI } from '@genial/components';
import { BoxBorder, Color } from '@genial/design-tokens';
import { Modal, ScrollView } from 'native-base';
import { Dimensions } from 'react-native';

import { useRecoilQuery } from '../../../../../../../../../hooks/useRecoilQuery';
import { fundDetailsQuery } from '../../../../../../../../../store/product/selectors';
import { useGlobalAssetContext } from '../../../../../contexts';
import { useFundsAssetContext } from '../../../../../contexts/products/Funds';

import {
  formatDocumentList,
  formatFundsDetailsData,
  formatFundsExtraDetailsData,
} from './constants';

export const ItemDetails = () => {
  const { height } = Dimensions.get('window');

  const { selectedTab, accountNumber } = useGlobalAssetContext();
  const { modalOpen, offerSelected, setModalOpen } = useFundsAssetContext();

  const { data, loading, error } = useRecoilQuery(
    fundDetailsQuery({
      accountNumber: accountNumber ? `${accountNumber}` : '25549',
      fundCnpj: offerSelected?.fundCnpj || '',
      fundId: offerSelected?.productId || '',
    })
  );

  if (!offerSelected) {
    return <></>;
  }

  const getOfferCaptions = (): FundsDetailsTypes.Caption[] => {
    if (!data?.data) {
      return [];
    }

    return selectedTab.captions
      .filter(({ icon }) => data.data.captions.includes(icon))
      .map((caption) => ({ ...caption, iconColor: Color[caption.iconColor] }));
  };

  return (
    <UI.Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} testId="modal-details">
      <Modal.Content
        alignItems={'center'}
        w={'full'}
        maxH={{ base: height * 0.75, lg: 'full' }}
        maxW={{ base: 'full', lg: '909px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}
        borderRadius={BoxBorder.heavy}>
        <ScrollView w={'full'} showsVerticalScrollIndicator={false}>
          <UI.FundsDetails
            testId={'modal-funds-details'}
            initials={data?.data.initials || '--'}
            title={data?.data.title || '--'}
            isMarketClosed={data?.data.isMarketClosed}
            marketStatus={data?.data.marketStatus}
            onClose={() => setModalOpen(false)}
            captions={getOfferCaptions()}
            data={formatFundsDetailsData(data?.data)}
            extraData={formatFundsExtraDetailsData(data?.data)}
            downloadList={formatDocumentList(data?.data)}
            isError={!!error}
            isLoading={loading}
            maxW={{ base: 'full', lg: '909px' }}
          />
        </ScrollView>
      </Modal.Content>
    </UI.Modal>
  );
};
